import React from 'react';

import { useHistory } from 'react-router-dom';

import { InsightsNewIconDualTone, InsightsNewIconHover, InsightsNewIconSelected } from 'assets/assetsV1/iconComponents';

import { getMatchesForCurrentRoute, goToPersonaInsights } from 'constants/helper';

import { NavItem } from 'uiToolkitV1/NavBar';

import { HeaderIconContainer } from './common/styles';

const PersonaInsightsHeader = () => {
  const history = useHistory();
  const { isPersonaInsightsMatch } = getMatchesForCurrentRoute(history.location.pathname, history.location);

  return (
    <HeaderIconContainer onClick={() => goToPersonaInsights(history)}>
      <NavItem
        Icon={InsightsNewIconDualTone}
        HoverIcon={InsightsNewIconHover}
        ActiveIcon={InsightsNewIconSelected}
        isActive={isPersonaInsightsMatch}
        isBetaFeature
      >
        Persona Insights
      </NavItem>
    </HeaderIconContainer>
  );
};

export default PersonaInsightsHeader;
